module.exports = __webpack_public_path__ + "/images/shop/icon/return.svg";